import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormsPanel from './FormsPanel';
import FormFindersPanel from './FormFindersPanel';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    contentSpacer: {
        marginTop: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(10),
        },
    },
}));

export default function Forms({ spacing }) {
    const classes = useStyles();

    return (
        <Grid container item xs={12} spacing={spacing} justifyContent="center" alignItems="center" direction="column">
            <div className={classes.contentSpacer} />
            <Grid item xs={12} sm={8} container spacing={spacing} direction="column">
                <Grid item>
                    <FormsPanel />
                </Grid>
                <Grid item>
                    <FormFindersPanel />
                </Grid>
            </Grid>
        </Grid>
    );
}
